export type FeatureFlags = Record<string, boolean>;

let flags: FeatureFlags = {};
const listeners = new Set<() => void>();

export function setFeatureFlags(next: FeatureFlags | undefined): void {
  flags = next ?? {};
  listeners.forEach((listener) => listener());
}

export function isFeatureFlagEnabled(flagName: string): boolean {
  return flags[flagName] === true;
}

export function subscribeToFeatureFlags(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
